import { render } from "./App.vue?vue&type=template&id=f934e03c&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f934e03c&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f934e03c"]])

export default __exports__